module.exports = __webpack_public_path__ + "img/a2_old.2a85206a.png";